import React from 'react';
import { Card, Input, MultipleSelect, Select } from '@avila-tek/ui/src';
import { Category, Company, Product, Tax, User } from '../../../../models';
import { ACTIONS, ACTIONS_TYPE } from './reducer';
import { priorities } from '../../../../static/priorities';
import TextAreaEditor from '../../TextAreaEditor';
import FormHeader from '../FormHeader';

interface ProductDataFormProps {
  product?: Product;
  categories: Category[];
  taxes: Tax[];
  state: Partial<Product>;
  dispatch: React.Dispatch<ACTIONS_TYPE>;
  allies: User[];
  ally?: User;
}

function ProductDataForm({
  product,
  categories,
  taxes,
  allies,
  state,
  dispatch,
  ally,
}: ProductDataFormProps) {
  const buildOptionsListTaxes = (_taxes: Tax[]) =>
    _taxes?.map((tax) => ({
      ...tax,
      _id: tax?._id,
      name: tax?.name,
    }));

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    dispatch({ type: name as any, payload: value });
  };

  const handleChangeSelect = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const { name, value } = e.target;
    dispatch({ type: name as any, payload: value });
  };

  const handleChangeSelectMultiple = (
    value: Array<Partial<Tax>>,
    name: string
  ) => {
    dispatch({
      type: name as any,
      payload: value as any,
    });
  };

  return (
    <Card>
      <FormHeader
        href="/app/products"
        backBtnText="Productos"
        title={product ? 'Actualizar producto' : 'Crear producto'}
      />
      <Card.Body>
        <div className="w-full flex md:flex-row flex-col gap-4">
          <div className="w-full">
            <Input
              name={ACTIONS.TITLE}
              value={state.title ?? ''}
              label="Título"
              required
              type="text"
              placeholder="Ingrese un título"
              onChange={handleChange}
            />
          </div>
          <div className="w-full">
            <Select
              name={ACTIONS.PRIORITY}
              value={state?.priority ?? 'none'}
              label="Prioridad"
              onChange={handleChangeSelect}
            >
              <option value="none" disabled>
                Seleccione una prioridad
              </option>
              {priorities.map((type) => (
                <option key={type.value} value={type.value}>
                  {type.name}
                </option>
              ))}
            </Select>
          </div>
        </div>
        <div className=" flex md:flex-row flex-col gap-4">
          <div className="w-full">
            <Select
              name={ACTIONS.CATEGORY}
              value={(state?.category as string) ?? ''}
              label="Categoría"
              onChange={handleChangeSelect}
            >
              <option value="" disabled>
                Seleccione un tipo de producto
              </option>
              {categories?.map((cat) => (
                <option key={cat._id} value={cat._id}>
                  {cat.name}
                </option>
              ))}
            </Select>
          </div>
          <div className="w-full">
            <Select
              name={ACTIONS.COMPANY}
              value={(state?.company as string) ?? ''}
              label="Aliado"
              onChange={handleChangeSelect}
              disabled={!!ally}
            >
              <option value="" disabled>
                Seleccione un aliado
              </option>
              {allies?.map((_ally) => (
                <option
                  key={(_ally.company as Company)._id}
                  value={(_ally.company as Company)._id}
                >
                  {(_ally.company as Company)?.name}
                </option>
              ))}
            </Select>
          </div>
        </div>
        <div className=" flex md:flex-row flex-col gap-4">
          <div className="w-full md:w-1/2 pr-2">
            <MultipleSelect
              actionName={ACTIONS.TAXES}
              defaultSelect={buildOptionsListTaxes(state?.taxes as Tax[]) ?? []}
              options={buildOptionsListTaxes(taxes) ?? []}
              label="Impuestos"
              onChangeSelect={handleChangeSelectMultiple}
              description="Seleccione los impuestos"
              className=""
            />
          </div>
        </div>
        <div className="w-full">
          <label className="block">
            <span className="text-gray-300 text-sm font-arial font-extrabold mb-2 tracking-wider ">
              Descripción
            </span>
            <TextAreaEditor
              value={state?.description ?? ''}
              onChange={(text) => {
                dispatch({
                  type: ACTIONS.DESCRIPTION as any,
                  payload: String(text),
                });
              }}
            />
          </label>
        </div>
      </Card.Body>
    </Card>
  );
}

export default ProductDataForm;
